import React from 'react';
import t from 'tcomb-form';
import { connect } from 'react-redux';
import { FormattedMessage, FormattedDate, FormattedTime, injectIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip'
import { Link } from 'react-router';
import * as CartActions from '../../actions/cart';
import * as _ from 'lodash';

const EMPTY_QUALITY_STRING = '--empty--'; // form placeholder for empty values, this value will be replaced before dispatching to api
const Form = t.form.Form;

const cartItem = t.struct({
    id: t.Number,
    documentStorageId: t.Number,
    quantity: t.Number,
    paperQuality: t.String,
});

const cartItems = t.list(cartItem);

const AgreementRequired = t.refinement(t.Boolean, function (value) {
    return value === true ? true : false;
});

const CartType = t.struct({
    cartItems: cartItems,
    sex: t.String,
    firstname: t.String,
    lastname: t.String,
    company: t.String,
    street: t.String,
    zip: t.String,
    city: t.String,
    country: t.String,
    phone: t.String,
    email: t.String,
    billingAddressSex: t.maybe(t.String),
    billingAddressFirstname: t.maybe(t.String),
    billingAddressLastname: t.maybe(t.String),
    billingAddressCompany: t.maybe(t.String),
    billingAddressStreet: t.maybe(t.String),
    billingAddressZip: t.maybe(t.String),
    billingAddressCity: t.maybe(t.String),
    billingAddressCountry: t.maybe(t.String),
    billingAddressPhone: t.maybe(t.String),
    billingAddressEmail: t.maybe(t.String),
    agreement: AgreementRequired,
    saveAddress: t.Boolean,
});

class FormCartToPrintShop extends React.Component {

    addressShortcuts = null;

    constructor(props, context) {

        super(props, context);

        this.addressShortcuts = _.get(props.app, 'config.addressShortcuts', null);

        const { items, deleteCartItem, user } = props;

        const listCartLayout = (locals) => {
            return (
                <table className="table table-sm table-striped table-hover">
                    <thead>
                    <tr>
                        <th><FormattedMessage id="LABEL_QUANTITY"/></th>
                        <th><FormattedMessage id="LABEL_PAPER_QUALITY"/></th>
                        <th><FormattedMessage id="LABEL_TITLE"/></th>
                        <th><FormattedMessage id="LABEL_CAMPAIGN"/></th>
                        <th><FormattedMessage id="LABEL_LANGUAGE"/></th>
                        <th><FormattedMessage id="LABEL_AUTHOR"/></th>
                        <th><FormattedMessage id="LABEL_UPDATED_AT"/></th>
                        <th></th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody className="cartItems">
                    {
                        locals.items.map((item, index) => {

                            const configuratorRoute = '/configurator/' + item.input.props.value.documentId + '/' + item.input.props.value.documentStorageId + '/0';
                            //
                            // here's the trick: setting the template on the fly and clone the item!
                            //
                            const options = {
                                auto: 'none',
                                fields: {
                                    'id': {
                                        type: 'hidden',
                                    },
                                    'documentStorageId': {
                                        type: 'hidden',
                                    },
                                    'quantity': {
                                        type: 'number',
                                        attrs: {
                                            min: 1
                                        },
                                        error: <FormattedMessage id="ERROR_REQUIRED"/>
                                    },
                                    'paperQuality': {
                                        type: 'hidden',
                                    }
                                },
                                template: (sublocals) => {
                                return (
                                    <tr key={item.key}>
                                        <td className="pieces">
                                          { sublocals.inputs.id }
                                          { sublocals.inputs.documentStorageId }
                                          { sublocals.inputs.quantity }
                                        </td>
                                        <td>
                                          { sublocals.inputs.paperQuality }
                                        </td>
                                        <td>{ item.input.props.value.storageName }</td>
                                        <td>{ item.input.props.value.campaign } { item.input.props.value.additionalInfos }</td>
                                        <td><FormattedMessage id={'LANGUAGE_' + item.input.props.value.locale}/></td>
                                        <td>{ item.input.props.value.author }</td>
                                        <td><FormattedDate value={ item.input.props.value.storageUpdatedAt }/> -
                                            <FormattedTime value={ item.input.props.value.storageUpdatedAt }/></td>
                                        <td>
                                            <Link to={configuratorRoute}>
                                                <FormattedMessage id="LABEL_TO_CONFIGURATOR">
                                                  {(message) => (
                                                    <i className="material-icons"
                                                       data-tip={ message }>create</i>
                                                  )}
                                                </FormattedMessage>
                                            </Link>
                                            <ReactTooltip />
                                        </td>
                                        <td>
                                            <FormattedMessage id="LABEL_CART_DELETE">
                                              {(message) => (
                                                <a onClick={() => { deleteCartItem(item.input.props.value.documentStorageId) }}>
                                                    <i className="material-icons" data-tip={ message }>remove_shopping_cart</i>
                                                </a>
                                              )}
                                            </FormattedMessage>
                                            <ReactTooltip />
                                        </td>
                                    </tr>
                                )
                            }
                        };

                        // Create dynamic paperQuality options
                        const paperQualities = item.input.props.value.paperQualities;
                        if (typeof paperQualities !== 'undefined' && paperQualities instanceof Array && paperQualities.length > 0) {
                            let paperQualityOptions = [];
                            paperQualities.map((paperQuality) => {
                                const translationKey = 'PAPER_QUALITY_' + paperQuality.toUpperCase();
                                paperQualityOptions.push(
                                    {
                                        text: this.props.intl.formatMessage({id: translationKey}),
                                        value: paperQuality,
                                    }
                                )
                            });
                            options.fields.paperQuality = {
                                factory: t.form.Select,
                                options: paperQualityOptions,
                                nullOption: {
                                    value: '',
                                    text: '-- ' + this.props.intl.formatMessage({id: 'LABEL_SELECT_PAPER_QUALITY'}) + ' --'
                                },
                                error: <FormattedMessage id="ERROR_REQUIRED"/>
                            }
                        }

                        return React.cloneElement(item.input, {
                            key: item.key,
                            options: options
                          })
                        })
                    }
                    </tbody>
                </table>
            );
        };


        const formLayout = (locals) => {

            // hash field name -> field input
            const inputs = locals.inputs;

            return (
                <div>
                    <div className="panel">
                        {inputs.cartItems}
                    </div>
                    <div className="row">
                        <fieldset className="col-md-6">
                            <div className="panel">
                                <div className="panel-heading">
                                    <h3 className="panel-title"><FormattedMessage id="LABEL_DELIVERY_ADDRESS"/></h3>
                                </div>
                                <div className="panel-body">
                                    <div className="row">
                                        <div className="col-xs-6">
                                            {inputs.sex}
                                        </div>
                                        <div className="col-xs-6">
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">
                                            {inputs.firstname}
                                        </div>
                                        <div className="col-xs-6">
                                            {inputs.lastname}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            {inputs.company}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            {inputs.street}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-4">
                                            {inputs.zip}
                                        </div>
                                        <div className="col-xs-8">
                                            {inputs.city}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            {inputs.country}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            {inputs.phone}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            {inputs.email}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset className="col-md-6" id="fieldsetBillingAddress"
                                  style={{display: (inputs.billingAddressSex.props.options.disabled === true) ? 'none' : 'block'}}>
                            <div className="panel">
                                <div className="panel-heading">
                                    <h3 className="panel-title"><FormattedMessage id="LABEL_BILLING_ADDRESS"/></h3>
                                </div>
                                <div className="panel-body">
                                    <div className="row">
                                        <div className="col-xs-6">
                                            {inputs.billingAddressSex}
                                        </div>
                                        <div className="col-xs-6">
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-6">
                                            {inputs.billingAddressFirstname}
                                        </div>
                                        <div className="col-xs-6">
                                            {inputs.billingAddressLastname}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            {inputs.billingAddressCompany}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            {inputs.billingAddressStreet}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-4">
                                            {inputs.billingAddressZip}
                                        </div>
                                        <div className="col-xs-8">
                                            {inputs.billingAddressCity}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            {inputs.billingAddressCountry}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            {inputs.billingAddressPhone}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            {inputs.billingAddressEmail}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            {inputs.agreement}
                            <p><FormattedMessage id="LABEL_HINT_CHECK_DOCUMENT"/></p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            {inputs.saveAddress}
                        </div>
                    </div>
                </div>
            );
        };

        const stateItems = this.prepareStateItems(items);
        const stateAddresses = this._defaultAddress(user);

        this.state = {
            formType: CartType,
            showBillingAddress: true,
            formValues: {...stateItems, ...stateAddresses},
            formOptions: {
                template: formLayout,
                fields: {
                    cartItems: {
                        template: listCartLayout
                        // fields and options will be set dynamically on  the fly
                    },
                    sex: {
                        label: <FormattedMessage id="LABEL_SALUTATION"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>,
                        nullOption: {
                            value: '',
                            text: '-- ' + this.props.intl.formatMessage({id: 'LABEL_SELECT_SALUTATION'}) + ' --'
                        },
                        factory: t.form.Select,
                        options: [
                            {value: '1', text: this.props.intl.formatMessage({id: 'LABEL_MRS'}) },
                            {value: '0', text:  this.props.intl.formatMessage({id: 'LABEL_MR'}) },
                        ],
                    },
                    firstname: {
                        label: <FormattedMessage id="LABEL_FIRSTNAME"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>
                    },
                    lastname: {
                        label: <FormattedMessage id="LABEL_LASTNAME"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>
                    },
                    company: {
                        label: <FormattedMessage id="LABEL_COMPANY"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>
                    },
                    street: {
                        label: <FormattedMessage id="LABEL_STREET"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>
                    },
                    zip: {
                        label: <FormattedMessage id="LABEL_ZIPCODE"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>
                    },
                    city: {
                        label: <FormattedMessage id="LABEL_CITY"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>
                    },
                    country: {
                        label: <FormattedMessage id="LABEL_COUNTRY"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>
                    },
                    phone: {
                        label: <FormattedMessage id="LABEL_PHONE"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>
                    },
                    email: {
                        label: <FormattedMessage id="LABEL_EMAIL"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>
                    },
                    billingAddressSex: {
                        label: <FormattedMessage id="LABEL_SALUTATION"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>,
                        nullOption: {
                            value: '',
                            text: '-- ' + this.props.intl.formatMessage({id: 'LABEL_SELECT_SALUTATION'}) + ' --'
                        },
                        factory: t.form.Select,
                        options: [
                            {value: '1', text: this.props.intl.formatMessage({id: 'LABEL_MRS'}) },
                            {value: '0', text:  this.props.intl.formatMessage({id: 'LABEL_MR'}) },
                        ]
                    },
                    billingAddressFirstname: {
                        label: <FormattedMessage id="LABEL_FIRSTNAME"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>,
                    },
                    billingAddressLastname: {
                        label: <FormattedMessage id="LABEL_LASTNAME"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>,
                    },
                    billingAddressCompany: {
                        label: <FormattedMessage id="LABEL_COMPANY"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>,
                    },
                    billingAddressStreet: {
                        label: <FormattedMessage id="LABEL_STREET"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>,
                    },
                    billingAddressZip: {
                        label: <FormattedMessage id="LABEL_ZIPCODE"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>,
                    },
                    billingAddressCity: {
                        label: <FormattedMessage id="LABEL_CITY"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>,
                    },
                    billingAddressCountry: {
                        label: <FormattedMessage id="LABEL_COUNTRY"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>,
                    },
                    billingAddressPhone: {
                        label: <FormattedMessage id="LABEL_PHONE"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>,
                    },
                    billingAddressEmail: {
                        label: <FormattedMessage id="LABEL_EMAIL"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>,
                    },
                    agreement: {
                        label: <FormattedMessage id="LABEL_PRINTSHOP_PROCCESSING_AGREEMENT"/>,
                        error: <FormattedMessage id="ERROR_REQUIRED"/>
                    },
                    saveAddress: {
                        label: <FormattedMessage id="LABEL_SAVE_ADDRESS"/>
                  },

                }
            }
        };

        this.save = this.save.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    static get defaultProps() {
        return {
            items: []
        }
    }

    onChange(value) {

      const { user } = this.props;

      let shortcut = null;
      if (shortcut = _.get(this.addressShortcuts, value.billingAddressCompany, null)) {

        let billingSex = _.get(user, 'billingAddressSex', _.get(user, 'sex', null));

        // we overlaod the address values by shortcut, the contact values will be loaded by current user
        const overloadValues = {
          billingAddressSex:  billingSex !== null ? billingSex.toString() : null,
          billingAddressFirstname: _.get(user, 'billingAddressFirstname', null),
          billingAddressLastname: _.get(user, 'billingAddressLastname', null),
          billingAddressCompany: _.get(shortcut, 'company', null),
          billingAddressStreet: _.get(shortcut, 'street', null),
          billingAddressZip: _.get(shortcut, 'zip', null),
          billingAddressCity: _.get(shortcut, 'city', null),
          billingAddressCountry: _.get(shortcut, 'country', null),
          billingAddressPhone: _.get(user, 'billingAddressPhone', null),
          billingAddressEmail: _.get(user, 'billingAddressEmail', null),
        };

        if (!overloadValues.billingAddressFirstname) {
          overloadValues.billingAddressFirstname = _.get(user, 'firstname', null);
        }
        if (!overloadValues.billingAddressLastname) {
          overloadValues.billingAddressLastname = _.get(user, 'lastname', null);
        }
        if (!overloadValues.billingAddressPhone) {
          overloadValues.billingAddressPhone = _.get(user, 'phone', null);
        }
        if (!overloadValues.billingAddressEmail) {
          overloadValues.billingAddressEmail = _.get(user, 'username', null);
        }

        const merged = {...value, ...overloadValues};

        this.setState({formValues: merged});
      }
    }

    save(event) {

        event.preventDefault();

        const { dispatch } = this.props;

        // call getValue() to get the values of the form
        const formValues = this.refs.form.getValue();

        // if validation fails, value will be null
        if (formValues) {

            let values = Object.assign({}, formValues);

            // Workaround to replace empty placeholder by null for paperQuality
            let preparedCartItems = [];
            values.cartItems.map((item, i) => {
                preparedCartItems.push(
                  {
                    id: item.id,
                    documentStorageId: item.documentStorageId,
                    quantity: item.quantity,
                    paperQuality: (item.paperQuality === EMPTY_QUALITY_STRING) ? null : item.paperQuality,
                  }
                );
            });

            values.cartItems = preparedCartItems;

            // console.log('Process cart:', values);

            dispatch(CartActions.processCart(values));
        }
    }

    _defaultAddress(user) {

        let billingAddressSex = _.get(user, 'billingAddressSex', null);

        const address = {
          firstname: user.firstname,
          lastname: user.lastname,
          sex: user.sex !== null ? user.sex.toString() : null,
          company: user.companyName,
          street: user.street,
          zip: user.zip,
          city: user.city,
          country: user.country,
          phone: user.phone,
          email: user.shoppingCartEmail ? user.shoppingCartEmail : user.email,
          billingAddressSex: billingAddressSex !== null ? billingAddressSex.toString() : null,
          billingAddressFirstname: _.get(user, 'billingAddressFirstname', null),
          billingAddressLastname: _.get(user, 'billingAddressLastname', null),
          billingAddressCompany: _.get(user, 'billingAddressCompany', null),
          billingAddressStreet: _.get(user, 'billingAddressStreet', null),
          billingAddressZip: _.get(user, 'billingAddressZip', null),
          billingAddressCity: _.get(user, 'billingAddressCity', null),
          billingAddressCountry: _.get(user, 'billingAddressCountry', null),
          billingAddressPhone: _.get(user, 'billingAddressPhone', null),
          billingAddressEmail: _.get(user, 'billingAddressEmail', null),
        };

        return address;
    }

    prepareStateItems(items) {
      // set the quantity to NULL - user should set the quantity in the form
      let cartItemValues = [...items];
      cartItemValues.map((item, i) => {
        item.quantity = null;
        if (!item.paperQualities) {
          item.paperQuality = EMPTY_QUALITY_STRING;
        }
      });

      return { cartItems: cartItemValues };
    }

    componentWillReceiveProps() {
      const { items } = this.props;
      this.setState({formValues: this.prepareStateItems(items)});
    }

    render() {

        return (
            <div className="cart-to-print-shop-form">
                <form onSubmit={event => this.save(event)}>
                    <Form
                        ref="form"
                        type={this.state.formType}
                        value={this.state.formValues}
                        options={this.state.formOptions}
                        onChange={ this.onChange }
                    />
                    <button className="btn btn-success" onClick={event => this.save(event)}><FormattedMessage id="LABEL_SEND_TO_PRINTSHOP"/></button>
                </form>
            </div>
        );
    }
}

export default connect(state => ({ cart: state.cart, user: state.user, app: state.app }))(injectIntl(FormCartToPrintShop));



// WEBPACK FOOTER //
// ./src/js/components/forms/FormCartToPrintShop.react.jsx